/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useEffect, useState } from "react";
import {
  addCard,
  getCardAppData,
  getCommunity,
  validateAccept,
} from "../../api/cardsApi";
import { getTranslations } from "../../api/translationsApi";
import { checkFormat, generateGuid } from "../../utils/common";
import {
  ARCA_MIMO_BIKE,
  ARCA_MIR,
  ARCA_TOUCH,
  ARCA_TRANSFER,
  EMAIL_REGEXP,
  MASTER_CARD_GOLD,
  MASTER_CARD_STANDARD,
  MOBILE_REGEXP,
  SSN_REGEXP,
  UPI_GOLD,
  UPI_PLATINUM,
  VISA_CLASSIC,
  VISA_GOLD,
  VISA_INFINITE,
  VISA_VISION_BLACK_STANDARD,
  VISA_VISION_WHITE_STANDARD,
  TRAVEL_CARD,
} from "../../utils/constants";
import Field from "../field/field";
import Loader from "../loader/loader";
import ZoomImg from "../zoomImg/zoomImg";
import "./cardForm.css";

function CardForm({ lang, card }) {
  const [translations, setTranslations] = useState({
    Titles: {
      FormTitle: "",
      VisaGoldOrder: "",
      VisaClassicOrder: "",
      VisaInfiniteOrder: "",
      MasterCardStandardOrder: "",
      MasterCardGoldOrder: "",
      ArcaMirOrder: "",
      ArcaTransferCardOrder: "",
      ArcaMimoBikeOrder: "",
      ArcaEvocaTouchOrder: "",
      UPIPlatinum: "",
      UPIGold: "",
      TravelCard: "",
    },
    Labels: {
      NameOfCompany: "",
      TIN: "",
      Currency: "",
      EmailAddress: "",
      PhoneNumber: "",
      Branch: "",
      CardType: "",
      CardCompany: "",
      DeliveryMode: "",
      State: "",
      Community: "",
      Street: "",
      BuildingOrHome: "",
      NumberOfHome: "",
      SSN: "",
      Passport: "",
      ExtractMethod: "",
      IsUSATaxPayer: "",
      AgreeTermsAndConditions: "",
      TermsAndConditions: "",
      Agree: "",
      IsAcraAccepted: "",
      ResidentOfTheRA: "",
      ResidentTerms: "",
    },
    Branches: [],
    Currencies: [],
    Buttons: {
      Send: "",
      Attach: "",
    },
    Messages: {
      Error: "",
      Required: "",
      CompanyNameError: "",
      TINError: "",
      NotValidFormat: "",
      YourApplicationIsSent: "",
      YourApplicationIsNotSent: "",
      AdditionalInfoMobile: "",
      FatcaClient: "",
    },
    PlaceHolder: {
      ChooseBranch: "",
      Choose: "",
      MobileExample: "",
    },
    ExtractMethods: [],
    ResidentAnswers: [],
  });

  const [cardData, setCardData] = useState({
    Branches: [],
    CardTypes: [],
    Companies: [],
    Currencies: [],
    DeliveryModes: [],
    States: [],
  });
  const [communityData, setCommunityData] = useState([]);
  const [passportBase64, setPassportBase64] = useState("");
  const [showZoomedImg, setShowZoomedImg] = useState(false);

  const [cardType, setCardType] = useState("");
  const [cardCompany, setCardCompany] = useState("");
  const [currency, setCurrency] = useState("");
  const [deliveryMode, setDeliveryMode] = useState("");
  const [branch, setBranch] = useState("");
  const [deliveryState, setDeliveryState] = useState("");
  const [community, setCommunity] = useState("");
  const [deliveryStreet, setDeliveryStreet] = useState("");
  const [deliveryHouseOrBuilding, setDeliveryHouseOrBuilding] = useState("");
  const [deliveryNumberOfHouse, setDeliveryNumberOfHouse] = useState("");
  const [ssn, setSsn] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [passport, setPassport] = useState("");
  const [extractMethod, setExtractMethod] = useState("");
  const [isAcraAccepted, setIsAcraAccepted] = useState(true);
  const [usaTaxPayer, setUsaTaxPayer] = useState(false);
  const [termsAndConditionsLinkClicked, setTermsAndConditionsLinkClicked] =
    useState(false);
  const [agreeTermAndConditions, setAgreeTermAndConditions] = useState(false);
  const [residentOfRA, setResidentOfRA] = useState("");
  const [residenceTermsUrlClicked, setResidenceTermsUrlClicked] =
    useState(false);

  const [cardTypeError, setCardTypeError] = useState("");
  const [cardCompanyError, setCardCompanyError] = useState("");
  const [currencyError, setCurrencyError] = useState("");
  const [deliveryModeError, setDeliveryModeError] = useState();
  const [branchError, setBranchError] = useState("");
  const [deliveryStateError, setDeliveryStateError] = useState("");
  const [communityError, setCommunityError] = useState("");
  const [deliveryStreetError, setDeliveryStreetError] = useState("");
  const [deliveryHouseOrBuildingError, setDeliveryHouseOrBuildingError] =
    useState("");
  const [deliveryNumberOfHouseError] = useState("");
  const [ssnError, setSsnError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [passportError, setPassportError] = useState("");
  const [extractMethodError, setExtractMethodError] = useState("");
  const [isAcraAcceptedError] = useState(false);
  const [usaTaxPayerError] = useState(false);
  const [agreeTermAndConditionsError, setAgreeTermAndConditionsError] =
    useState(false);
  const [residentOfRAError, setResidentOfRAError] = useState("");

  const [showLoading, setShowLoading] = useState(true);
  const [showButton, setShowButton] = useState(false);
  const [formInfoMessage, setFormInfoMessage] = useState(null);
  const [isAcceptedEver, setIsAcceptedEver] = useState(false);
  const [isEvocaBankUser, setIsEvocaBankUser] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    getTranslations(lang)
      .then((result) => setTranslations(result))
      .then(() =>
        getCardAppData(lang).then((cardData) => {
          if (cardData && cardData.DeliveryModes.length === 1) {
            setDeliveryMode(cardData.DeliveryModes[0].value);
          }
          setCardData(cardData);
          init(cardData);
        })
      );
  }, []);

  const init = () => {
    switch (card) {
      case ARCA_TRANSFER: {
        setCardType("001");
        setCardCompany("162");
        break;
      }
      case ARCA_MIR: {
        setCardType("001");
        setCardCompany("126");
        break;
      }
      case ARCA_MIMO_BIKE: {
        setCardType("001");
        setCardCompany("245");
        break;
      }
      case ARCA_TOUCH: {
        setCardType("001");
        setCardCompany("601");
        break;
      }
      case MASTER_CARD_STANDARD: {
        setCardType("003");
        setCardCompany("760");
        break;
      }
      case MASTER_CARD_GOLD: {
        setCardType("004");
        setCardCompany("760");
        break;
      }
      case VISA_CLASSIC: {
        setCardType("006");
        break;
      }
      case VISA_GOLD: {
        setCardType("007");
        break;
      }
      case VISA_INFINITE: {
        setCardType("008");
        break;
      }
      case VISA_VISION_WHITE_STANDARD: {
        setCardType("009");
        setCardCompany("618");
        break;
      }
      case VISA_VISION_BLACK_STANDARD: {
        setCardType("009");
        setCardCompany("619");
        break;
      }
      case UPI_PLATINUM: {
        setCardType("010");
        setCardCompany("701");
        break;
      }
      case UPI_GOLD: {
        setCardType("011");
        setCardCompany("670");
        break;
      }
      case TRAVEL_CARD: {
        setCardType("014");
        setCardCompany("760");
        break;
      }
    }
  };

  const handleOnClick = (event) => {
    const { name, value } = event.target;
    if (name === "link") {
      setTermsAndConditionsLinkClicked(true);
    } else if (name === "passportImage") {
      setShowZoomedImg(true);
    } else {
      validate(name, value);
    }
  };

  const handleChange = (event) => {
    const { value, name, checked } = event.target;
    switch (name) {
      case "cardType": {
        if (value !== "001") setCardCompany("");
        setCardType(value);
        break;
      }
      case "cardCompany": {
        setCardCompany(value);
        break;
      }
      case "currency": {
        setCurrency(value);
        break;
      }
      case "deliveryMode": {
        setDeliveryMode(value);
        break;
      }
      case "isEvocaUser": {
        setIsEvocaBankUser(checked);
        break;
      }
      case "state": {
        setDeliveryState(value);
        getCommunity(value, lang)
          .then((data) => {
            setCommunityData(data);
          })
          .catch(() => {
            setCommunity("");
            setCommunityData([]);
          });
        break;
      }
      case "community": {
        setCommunity(value);
        break;
      }
      case "deliveryStreet": {
        setDeliveryStreet(value);
        break;
      }
      case "deliveryHouseOrBuilding": {
        setDeliveryHouseOrBuilding(value);
        break;
      }
      case "deliveryNumberOfHouse": {
        setDeliveryNumberOfHouse(value);
        break;
      }
      case "email": {
        setEmail(value);
        break;
      }
      case "phone": {
        setPhone(value);
        break;
      }
      case "branch": {
        setBranch(value);
        break;
      }
      case "ssn": {
        setSsn(value);
        break;
      }
      case "resident-terms": {
        window.open(
          `https://www.evoca.am/${lang}/customer-residency-criteria`,
          "_blank"
        );
        setResidenceTermsUrlClicked(true);
        break;
      }
      case "passport": {
        const file = event.target.files[0];
        const reader = new FileReader();
        setPassport(value);
        reader.onload = (upload) => {
          setPassportBase64(upload.target.result);
        };
        if (file) reader.readAsDataURL(file);
        else setPassportBase64("");
        break;
      }
      case "extractMethod": {
        setExtractMethod(value);
        break;
      }
      case "usaTaxPayer": {
        setUsaTaxPayer(checked);
        break;
      }
      case "IsAcraAccepted": {
        setIsAcraAccepted(checked);
        break;
      }
      case "agreeTermAndConditions": {
        setAgreeTermAndConditions(checked);
        break;
      }
      case "residentOfRA": {
        setResidentOfRA(value);
        break;
      }
      default: {
        break;
      }
    }
    validate(name, value, checked);
  };

  const validate = (name, value, checked) => {
    switch (name) {
      case "cardType": {
        setCardTypeError(!value ? translations.Messages.Required : null);
        break;
      }
      case "cardCompany": {
        setCardCompanyError(!value ? translations.Messages.Required : null);
        break;
      }
      case "currency": {
        setCurrencyError(!value ? translations.Messages.Required : null);
        break;
      }
      case "deliveryMode": {
        setDeliveryModeError(!value ? translations.Messages.Required : null);
        break;
      }
      case "branch": {
        setBranchError(!value ? translations.Messages.Required : null);
        break;
      }
      case "state": {
        setDeliveryStateError(!value ? translations.Messages.Required : null);
        break;
      }
      case "community": {
        setCommunityError(!value ? translations.Messages.Required : null);
        break;
      }
      case "deliveryStreet": {
        setDeliveryStreetError(!value ? translations.Messages.Required : null);
        break;
      }
      case "deliveryHouseOrBuilding": {
        setDeliveryHouseOrBuildingError(
          !value ? translations.Messages.Required : null
        );
        break;
      }
      // case "deliveryNumberOfHouse": {
      //     setDeliveryNumberOfHouseError(!value ? translations.Messages.Required : null);
      //     break;
      // }
      case "email": {
        setEmailError(
          !value
            ? translations.Messages.Required
            : checkFormat(value, EMAIL_REGEXP)
            ? translations.Messages.NotValidFormat
            : null
        );
        break;
      }
      case "phone": {
        setPhoneError(
          !value
            ? translations.Messages.Required
            : checkFormat(value, MOBILE_REGEXP)
            ? translations.Messages.NotValidFormat
            : null
        );
        break;
      }
      case "ssn": {
        setSsnError(
          !value
            ? translations.Messages.Required
            : checkFormat(value, SSN_REGEXP)
            ? translations.Messages.NotValidFormat
            : null
        );
        if (!checkFormat(value, SSN_REGEXP) && value.length === 10) {
          validateAccept(value, lang)
            .then((isAccepted) => {
              setIsAcceptedEver(!isAccepted);
            })
            .catch(() => {
              setIsAcceptedEver(false);
            });
        } else {
          setIsAcceptedEver(false);
        }
        break;
      }
      case "passport": {
        setPassportError(!value ? translations.Messages.Required : null);
        break;
      }
      case "extractMethod": {
        setExtractMethodError(!value ? translations.Messages.Required : null);
        break;
      }
      // case "usaTaxPayer": {
      //     setUsaTaxPayerError(!checked ? translations.Messages.Required : null);
      //     break;
      //
      case "residentOfRA": {
        setResidentOfRAError(!value ? translations.Messages.Required : null);
        break;
      }
      case "agreeTermAndConditions": {
        setAgreeTermAndConditionsError(
          !value ? translations.Messages.Required : null
        );
        break;
      }
      default: {
        break;
      }
    }
  };

  const handleSubmit = (event) => {
    const Applicant = {};
    const Card = {};

    Applicant.SSN = ssn;
    Applicant.Mobile = phone;
    Applicant.Email = email;
    Applicant.USATaxPayee = usaTaxPayer;
    Applicant.Passport = passportBase64.split(";base64,")[1];
    Applicant.Device = `evocaweb${generateGuid()}`;
    Applicant.OzFolderId = null;
    Applicant.IsPolice = null;
    Applicant.BirthDate = null;
    Applicant.IsAcraAccepted = !isAcceptedEver ? null : isAcraAccepted;
    Applicant.IsResident = residentOfRA;

    Card.CardType = cardType;
    Card.Company = cardCompany;
    Card.Currency = currency;
    Card.Place = deliveryMode;
    Card.Branch = branch;
    Card.CommunicationType = extractMethod;

    const deliveryStateName = cardData.States?.filter?.(
      (i) => i.value === deliveryState
    )?.[0]?.text;
    const deliveryCommunityName = communityData?.filter?.(
      (i) => i?.value === community
    )[0]?.text;
    Card.Address = `${deliveryStateName}, ${deliveryCommunityName}, ${deliveryStreet}, ${deliveryHouseOrBuilding}, ${
      deliveryNumberOfHouse ? deliveryNumberOfHouse : ""
    } `;
    Card.InfinityUrl = null;
    Card.WithLoan = null;
    const cardApplication = { Applicant, Card };
    setLoader(true);
    addCard(cardApplication, lang)
      .then((response) => {
        setLoader(false);
        setShowLoading(false);
        setTimeout(() => {
          const { status } = response;
          if (status === 202 || status === 201)
            setFormInfoMessage(translations.Messages.YourApplicationIsSent);
          else
            setFormInfoMessage(translations.Messages.YourApplicationIsNotSent);
          setShowLoading(true);
          setShowButton(true);
        }, 2000);
      })
      .catch(() => {
        alert("Server Error");
        setLoader(false);
      });
    event.preventDefault();
  };

  const returnTitle = () => {
    let result;
    switch (card) {
      case VISA_GOLD: {
        result = translations.Titles.VisaGoldOrder;
        break;
      }
      case VISA_CLASSIC: {
        result = translations.Titles.VisaClassicOrder;
        break;
      }
      case VISA_INFINITE: {
        result = translations.Titles.VisaInfiniteOrder;
        break;
      }
      case MASTER_CARD_STANDARD: {
        result = translations.Titles.MasterCardStandardOrder;
        break;
      }
      case MASTER_CARD_GOLD: {
        result = translations.Titles.MasterCardGoldOrder;
        break;
      }
      case ARCA_MIR: {
        result = translations.Titles.ArcaMirOrder;
        break;
      }
      case ARCA_TOUCH: {
        result = translations.Titles.ArcaEvocaTouchOrder;
        break;
      }
      case ARCA_TRANSFER: {
        result = translations.Titles.ArcaTransferCardOrder;
        break;
      }
      case ARCA_MIMO_BIKE: {
        result = translations.Titles.ArcaMimoBikeOrder;
        break;
      }
      case VISA_VISION_WHITE_STANDARD: {
        result = translations.Titles.VisionWhiteOrder;
        break;
      }
      case VISA_VISION_BLACK_STANDARD: {
        result = translations.Titles.VisionBlackOrder;
        break;
      }
      case UPI_PLATINUM: {
        result = translations.Titles.UPIPlatinum;
        break;
      }
      case UPI_GOLD: {
        result = translations.Titles.UPIGold;
        break;
      }
      case TRAVEL_CARD: {
        result = translations.Titles.TravelCard;
        break;
      }
    }
    return result;
  };

  const onCloseZoomedImg = () => {
    setShowZoomedImg(false);
  };

  return (
    <div className="main-container">
      {passportBase64 && showZoomedImg && (
        <ZoomImg base64={passportBase64} onCloseZoomedImg={onCloseZoomedImg} />
      )}
      {
        <div className="form-body">
          <form
            className="container-form"
            onSubmit={(event) => handleSubmit(event)}
          >
            <div className="container-title">
              <h2 className="form-title">{returnTitle(card)}</h2>
            </div>
            {!(
              card === VISA_GOLD ||
              card === VISA_CLASSIC ||
              card === VISA_INFINITE ||
              card === MASTER_CARD_STANDARD ||
              card === MASTER_CARD_GOLD ||
              card === ARCA_MIR ||
              card === ARCA_MIMO_BIKE ||
              card === ARCA_TOUCH ||
              card === ARCA_TRANSFER ||
              card === VISA_VISION_BLACK_STANDARD ||
              card === VISA_VISION_WHITE_STANDARD ||
              card === UPI_GOLD ||
              card === UPI_PLATINUM ||
              card === TRAVEL_CARD
            ) &&
              cardData.CardTypes.length > 0 && (
                <Field
                  name={translations.Labels.CardType}
                  type="dropdown"
                  options={cardData.CardTypes}
                  handleOnClick={handleOnClick}
                  handleChange={handleChange}
                  inputName="cardType"
                  value={cardType}
                  errorMessage={cardTypeError}
                  placeHolder={translations.PlaceHolder.Choose}
                />
              )}
            {!(
              card === ARCA_MIR ||
              card === ARCA_MIMO_BIKE ||
              card === ARCA_TOUCH ||
              card === ARCA_TRANSFER
            ) &&
              cardData.Companies.length > 0 &&
              cardType === "001" && (
                <Field
                  name={translations.Labels.CardCompany}
                  type="dropdown"
                  options={cardData.Companies}
                  handleOnClick={handleOnClick}
                  handleChange={handleChange}
                  inputName="cardCompany"
                  value={cardCompany}
                  errorMessage={cardCompanyError}
                  placeHolder={translations.PlaceHolder.Choose}
                />
              )}
            {cardData.Currencies.length > 0 && (
              <Field
                name={translations.Labels.Currency}
                type="dropdown"
                options={
                  cardType === "009" ||
                  cardType === "911" ||
                  cardType === "921" ||
                  cardType === "010" ||
                  cardType === "011" ||
                  cardType === "014"
                    ? cardData.Currencies.filter((type) => type.value !== "058")
                    : cardData.Currencies
                }
                handleOnClick={handleOnClick}
                handleChange={handleChange}
                inputName="currency"
                value={currency}
                errorMessage={currencyError}
                placeHolder={translations.PlaceHolder.Choose}
              />
            )}
            {cardData.DeliveryModes.length > 0 &&
              cardData.DeliveryModes.length !== 1 && (
                <Field
                  name={translations.Labels.DeliveryMode}
                  type="dropdown"
                  options={cardData.DeliveryModes}
                  handleOnClick={handleOnClick}
                  handleChange={handleChange}
                  inputName="deliveryMode"
                  value={deliveryMode}
                  errorMessage={deliveryModeError}
                  placeHolder={translations.PlaceHolder.Choose}
                />
              )}
            {cardData.Branches.length > 0 && deliveryMode === "1" && (
              <Field
                name={translations.Labels.Branch}
                type="dropdown"
                options={cardData.Branches}
                handleOnClick={handleOnClick}
                handleChange={handleChange}
                inputName="branch"
                value={branch}
                errorMessage={branchError}
                placeHolder={translations.PlaceHolder.Choose}
              />
            )}
            {cardData.States.length > 0 && deliveryMode === "2" && (
              <Field
                name={translations.Labels.State}
                type="dropdown"
                options={cardData.States}
                handleOnClick={handleOnClick}
                handleChange={handleChange}
                inputName="state"
                value={deliveryState}
                errorMessage={deliveryStateError}
                placeHolder={translations.PlaceHolder.Choose}
              />
            )}
            {communityData.length > 0 && deliveryMode === "2" && (
              <Field
                name={translations.Labels.Community}
                type="dropdown"
                options={communityData}
                handleOnClick={handleOnClick}
                handleChange={handleChange}
                inputName="community"
                value={community}
                errorMessage={communityError}
                placeHolder={translations.PlaceHolder.Choose}
              />
            )}
            {communityData.length > 0 && deliveryMode === "2" && (
              <Fragment>
                <div className="address-cls">
                  <Field
                    name={translations.Labels.Street}
                    handleChange={handleChange}
                    inputName="deliveryStreet"
                    value={deliveryStreet}
                    errorMessage={deliveryStreetError}
                    handleOnClick={handleOnClick}
                  />
                  <Field
                    name={translations.Labels.BuildingOrHome}
                    handleChange={handleChange}
                    inputName="deliveryHouseOrBuilding"
                    value={deliveryHouseOrBuilding}
                    errorMessage={deliveryHouseOrBuildingError}
                    handleOnClick={handleOnClick}
                  />
                  <Field
                    name={translations.Labels.NumberOfHome}
                    handleChange={handleChange}
                    inputName="deliveryNumberOfHouse"
                    value={deliveryNumberOfHouse}
                    errorMessage={deliveryNumberOfHouseError}
                    handleOnClick={handleOnClick}
                    notRequired={true}
                  />
                </div>
              </Fragment>
            )}
            <Field
              name={translations.Labels.SSN}
              handleChange={handleChange}
              inputName="ssn"
              value={ssn}
              errorMessage={ssnError}
              handleOnClick={handleOnClick}
            />
            <Field
              name={translations.Labels.PhoneNumber}
              handleChange={handleChange}
              inputName="phone"
              value={phone}
              errorMessage={phoneError}
              handleOnClick={handleOnClick}
              placeHolder={translations.PlaceHolder.MobileExample}
              additionalInfo={translations.Messages.AdditionalInfoMobile}
            />
            <Field
              name={translations.Labels.EmailAddress}
              handleChange={handleChange}
              inputName="email"
              value={email}
              errorMessage={emailError}
              handleOnClick={handleOnClick}
            />

            <Field
              name={translations.Labels.Passport}
              handleChange={handleChange}
              inputName="passport"
              value={passport}
              errorMessage={passportError}
              handleOnClick={handleOnClick}
              type="file"
              placeHolder={translations.Buttons.Attach}
            />
            {passportBase64 && (
              <div className="image-space">
                <img
                  onClick={(event) => handleOnClick(event)}
                  name="passportImage"
                  src={passportBase64}
                  className="passport-image"
                  alt="passport-image"
                />
              </div>
            )}
            <Field
              name={translations.Labels.ExtractMethod}
              type="dropdown"
              options={translations.ExtractMethods}
              handleOnClick={handleOnClick}
              handleChange={handleChange}
              inputName="extractMethod"
              value={extractMethod}
              errorMessage={extractMethodError}
              placeHolder={translations.PlaceHolder.Choose}
            />

            <Field
              name={translations.Labels.ResidentOfTheRA}
              type="dropdown"
              options={translations.ResidentAnswers}
              handleOnClick={handleOnClick}
              handleChange={handleChange}
              inputName="residentOfRA"
              value={residentOfRA}
              errorMessage={residentOfRAError}
              placeHolder={translations.PlaceHolder.Choose}
              // disabled={!residenceTermsUrlClicked}
            />
            {/* <div className="field">
              <a
                className="underline-cls"
                name="resident-terms"
                onClick={(event) => handleChange(event)}
              >
                {translations.Labels.ResidentTerms}
              </a>
            </div> */}

            <Field
              name={translations.Labels.Client}
              handleChange={handleChange}
              inputName="isEvocaUser"
              type="checkbox"
              value={isEvocaBankUser}
              lang={lang}
              notRequired
            />

            <Field
              name={translations.Labels.IsUSATaxPayer}
              handleChange={handleChange}
              inputName="usaTaxPayer"
              type="checkbox"
              value={usaTaxPayer}
              errorMessage={usaTaxPayerError}
              handleOnClick={handleOnClick}
              notRequired={true}
            />

            {isAcceptedEver && (
              <Field
                name={translations.Labels.IsAcraAccepted}
                handleChange={handleChange}
                inputName="IsAcraAccepted"
                type="checkbox"
                value={isAcraAccepted}
                errorMessage={isAcraAcceptedError}
                handleOnClick={handleOnClick}
                notRequired={true}
              />
            )}

            <Field
              name={translations.Labels.AgreeTermsAndConditions}
              handleChange={handleChange}
              inputName="agreeTermAndConditions"
              type="checkbox"
              value={agreeTermAndConditions}
              errorMessage={agreeTermAndConditionsError}
              handleOnClick={handleOnClick}
              disabled={!termsAndConditionsLinkClicked}
              lang={lang}
              additionalText={translations.Labels.Agree}
            />
            <span class="agreement_desc">
              {translations.Labels.AgreementDescription}
            </span>

            <div className="show-loading" hidden={showLoading}>
              <Loader showLoading={showLoading} />
            </div>

            {loader ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0,0,0,0.2)",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  zIndex: 10000,
                }}
              >
                <Loader showLoading={loader} />
              </div>
            ) : (
              <></>
            )}

            <div className="application-result" hidden={!usaTaxPayer}>
              <h2 className="fatca-message" hidden={!usaTaxPayer}>
                {translations.Messages.FatcaClient}
              </h2>
            </div>

            <div
              className="application-result"
              hidden={!(isEvocaBankUser && residentOfRA === "false")}
            >
              <p
                style={{ textAlign: "center" }}
                hidden={!(isEvocaBankUser && residentOfRA === "false")}
              >
                {translations.Labels.GoToTouch_1}{" "}
                <a href="https://onelink.to/evocatouch" target="_blank">
                  {translations.Labels.GoToTouch_2}
                </a>
              </p>
            </div>

            <div
              className="application-result"
              hidden={!(!isEvocaBankUser && residentOfRA === "false")}
            >
              <p
                style={{ textAlign: "center" }}
                hidden={!(!isEvocaBankUser && residentOfRA === "false")}
              >
                {translations.Labels.GoToBank}
                <a
                  href="https://www.evoca.am/hy/branches-and-atms/"
                  target="_blank"
                >
                  {translations.Labels.GoToBank2}
                </a>
              </p>
            </div>

            <div className="form-button-parent" hidden={showButton}>
              <button
                className="submit-btn-send"
                type="submit"
                hidden={showButton}
                disabled={
                  (!isEvocaBankUser && residentOfRA === "false") ||
                  (isEvocaBankUser && residentOfRA === "false") ||
                  !currency ||
                  (deliveryMode === "1" && !branch) ||
                  (deliveryMode === "2" &&
                    (!deliveryState ||
                      !community ||
                      !deliveryStreet ||
                      !deliveryHouseOrBuilding)) ||
                  !ssn ||
                  !phone ||
                  !email ||
                  !passport ||
                  !extractMethod ||
                  !agreeTermAndConditions ||
                  usaTaxPayer
                }
              >
                {translations.Buttons.Send}
              </button>
            </div>

            <div className="application-result">
              <h2 className="confirmation" hidden={!formInfoMessage}>
                {formInfoMessage}
              </h2>
            </div>
          </form>
        </div>
      }
    </div>
  );
}

export default CardForm;
